import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Grid, keyframes } from '@mui/material';
import styled from '@emotion/styled';

const duration = 1000;

const shrinkAway = keyframes`
    0% {
        transform: scale(1);
        opacity: 1;
        height: auto;
        margin: 0;
        padding: 0;
    }
    50% {
        transform: scale(0.5);
        opacity: 0.5;
        height: auto;
        margin: 0;
        padding: 0;
    }
    100% {
        transform: scale(0);
        opacity: 0;
        height: 0;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
`;

const GridRowAnimate = styled(Grid)`
    position: relative;

    &:after {
        content: ' ';
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: rgba(224, 224, 224, 1);
        top: 8px;
        left: 0;
    }

    &.shrink-enter {
        transform: scale(1);
        opacity: 1
    }

    &.shrink-exit-done {
        display: none;
    }

    &.shrink-exit {
        animation: ${shrinkAway} ${duration}ms ease-out forwards;
    }
`;

export const VideoFxRow = ({ in: inProp, uuid, children }) => {
  const nodeRef = useRef(null);
  return (
    <CSSTransition data-uuid={uuid} nodeRef={nodeRef} in={inProp} timeout={duration} classNames="shrink">
      <GridRowAnimate data-in-prop={inProp} item xs={12} sx={{ pt: 4 }} ref={nodeRef}>
        {children}
      </GridRowAnimate>
    </CSSTransition>
  );
};